<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div>
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="startupCostsExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->
        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Startup Costs Tabs -->
    <startup-costs-tabs v-if="!loading" class="mb-4" />
    <!-- /Startup Costs Tabs -->

    <!-- Startup Costs List -->
    <startup-costs-list class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Startup Costs List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'setup'"
      :step="'startup-cost'"
      :concept-name="'startupCostMoreDetails'"
      :completed-step-name="'startupCostsCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="startupCostsExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="startup-cost"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>
import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import StartupCostsList from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/StartupCost/StartupCostsList.vue'
import StartupCostsTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/StartupCost/StartupCostsTabs.vue'

export default {
  name: 'ExpensesStartupCosts',

  components: {
    StartupCostsList,
    StartupCostsTabs,
    AddMoreDetails,
    AiBuddyDrawer,
    InfoGuide,
    InfoGuideDrawer,
    Loader
  },

  mixins: [
    MixinGuide,
    MixinIdeaRoles,
    MixinAiBuddyDrawer,
    MixinAiTemplate
  ],

  data () {
    return {
      loading: false
    }
  },

  mounted () {
    this.openGuide('startupCostFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('loading')
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
